<template>
  <div class="map__wrap">
    <div v-if="!kakao" class="store-map-info__container">
      <div class="name">{{storeMapInfo.storeName}}</div>
      <div class="address">{{storeMapInfo.storeAddress}}</div>
      <div class="line"></div>
      <div class="bottom">
        <div class="left">
          <div>전화번호</div>
          <div>영업시간</div>
          <div v-if="Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && $store.state.storeInfo.VIEW_TYPE !== '1'">배달가능시간</div>
          <div v-if="$store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
            $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
            $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
            $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
            $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '031_00000120'">휴무</div>
        </div>
        <div class="right">
          <div v-if="$store.state.storeInfo.STORE_SEQ === '055_00000287'">
            <a class="store-tel-link" href="tel: 01097702516">010 - 9770 - 2516</a>
          </div>
          <div v-else-if="$store.state.storeInfo.STORE_SEQ === '010_12345897'">
            <a class="store-tel-link" href="tel: 01044730202">010 - 4473 - 0202</a>
          </div>
          <div v-else>
            <a class="store-tel-link" :href="`tel: ${storeMapInfo.storeTel}`">{{storeMapInfo.storeTel}}</a>
          </div>
          <div v-if="!$empty($store.state.storeInfo.storeHourInfo) && Number($store.state.storeInfo.storeHourInfo.type) === 0">
            <div v-if="$store.state.storeInfo.storeHourInfo.body[0].startDate === $store.state.storeInfo.storeHourInfo.body[0].endDate">
              24시간
            </div>
            <div v-else>
              {{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(2)}}
              ~
              {{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(2)}}
            </div>
          </div>
          <div v-else-if="!$empty($store.state.storeInfo.storeHourInfo) && Number($store.state.storeInfo.storeHourInfo.type) === 1">
            <template v-if="!$empty($store.state.storeInfo.storeHourInfo.body[0].dayOfWeek) && $store.state.storeInfo.storeHourInfo.body[0].dayOfWeek.length === 5">
              주중 : {{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(2)}} ~
                {{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(2)}}
              주말 : {{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(2)}} ~
              {{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(2)}}
            </template>
            <template v-else>
              주중 : {{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(2)}} ~
                {{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(2)}}
              주말 : {{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(2)}} ~
              {{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(2)}}
            </template>
          </div>
          <div v-else-if="!$empty($store.state.storeInfo.storeHourInfo) && Number($store.state.storeInfo.storeHourInfo.type) === 2">
            <div v-for="(day, index) in $store.state.storeInfo.storeHourInfo.body" :key="index" style="text-align: left;">
              <span v-for="(week, index2) in day.dayOfWeek" :key="index2">{{week}}<span v-if="!$empty(day.dayOfWeek) && index2 + 1 < day.dayOfWeek.length">, </span></span> :
              {{$store.state.storeInfo.storeHourInfo.body[index].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[index].startDate.substr(2)}} ~
              {{$store.state.storeInfo.storeHourInfo.body[index].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[index].endDate.substr(2)}}
            </div>
          </div>
          <div v-if="Number($store.state.storeInfo.DELIVERY_FLAG) !== 0 && $store.state.storeInfo.VIEW_TYPE !== '1'">
            {{deliveryTimeValue}}
          </div>
          <div v-if="$store.state.storeInfo.STORE_SEQ !== '031_00000118' && $store.state.storeInfo.STORE_SEQ !== '041_00000018' &&
            $store.state.storeInfo.STORE_SEQ !== '041_00000017' && $store.state.storeInfo.STORE_SEQ !== '041_00000016' &&
            $store.state.storeInfo.STORE_SEQ !== '041_00000015' && $store.state.storeInfo.STORE_SEQ !== '041_00000019' &&
            $store.state.storeInfo.STORE_SEQ !== '032_00000036' && $store.state.storeInfo.STORE_SEQ !== '043_00000018' &&
            $store.state.storeInfo.STORE_SEQ !== '043_00000019' && $store.state.storeInfo.STORE_SEQ !== '031_00000120'">
            {{$store.state.storeInfo.DAY_OFF}}
          </div>
        </div>
      </div>
      <!-- <div class="store-map-info__contents number">
        <span>전화번호</span><a class="store-tel-link" :href="`tel: ${storeMapInfo.storeTel}`">{{storeMapInfo.storeTel}}</a>
      </div>
      <div v-if="$store.state.storeInfo.STORE_SEQ === '055_00000287'" class="store-map-info__contents number">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a class="store-tel-link" href="tel: 01097702516">010 - 9770 - 2516</a>
      </div>
      <div class="store-map-info__contents address" v-if="!$empty($store.state.storeInfo.storeHourInfo) && Number($store.state.storeInfo.storeHourInfo.type) === 0">
        <div v-if="$store.state.storeInfo.storeHourInfo.body[0].startDate === $store.state.storeInfo.storeHourInfo.body[0].endDate">
          <span class="store-map-info-title">매장 운영시간:</span> 24시간
        </div>
        <div v-else>
          <span class="store-map-info-title">매장 운영시간:</span>
          {{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(2)}}
          ~
          {{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(2)}}
        </div>
      </div>
      <div class="store-map-info__contents address" v-else-if="!$empty($store.state.storeInfo.storeHourInfo) && Number($store.state.storeInfo.storeHourInfo.type) === 1">
        <span class="store-map-info-title">매장 운영시간</span>
        <ul v-if="$store.state.storeInfo.storeHourInfo.body[0].dayOfWeek.length === 5">
          <li>주중 : {{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(2)}} ~
            {{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(2)}}</li>
          <li>주말 : {{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(2)}} ~
            {{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(2)}}</li>
        </ul>
        <ul v-else>
          <li>주중 : {{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].startDate.substr(2)}} ~
            {{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[1].endDate.substr(2)}}</li>
          <li>주말 : {{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].startDate.substr(2)}} ~
            {{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[0].endDate.substr(2)}}</li>
        </ul>
      </div>
      <div class="store-map-info__contents address" v-else-if="!$empty($store.state.storeInfo.storeHourInfo) && Number($store.state.storeInfo.storeHourInfo.type) === 2">
        <span class="store-map-info-title">매장 운영시간</span>
        <ul>
          <li v-for="(day, index) in $store.state.storeInfo.storeHourInfo.body" :key="index">
            <span v-for="(week, index2) in day.dayOfWeek" :key="index2">{{week}}<span v-if="index2 + 1 < day.dayOfWeek.length">, </span></span> :
            {{$store.state.storeInfo.storeHourInfo.body[index].startDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[index].startDate.substr(2)}} ~
            {{$store.state.storeInfo.storeHourInfo.body[index].endDate.substr(0, 2)}}:{{$store.state.storeInfo.storeHourInfo.body[index].endDate.substr(2)}}</li>
        </ul>
      </div>
      <div class="store-map-info__contents address" v-if="!$empty($store.state.storeInfo.DAY_OFF)">
        <span class="store-map-info-title">휴일:</span>{{$store.state.storeInfo.DAY_OFF}}
      </div>
      <div class="store-map-info__contents address" v-if="Number($store.state.storeInfo.DELIVERY_FLAG) !== 0">
        <span class="store-map-info-title">배달 가능시간:</span>{{deliveryTimeValue}}
      </div> -->
    </div>
    <div v-if="$route.query.seq !== '051_00000876'" class="map__container">
      <div ref="maps"></div>
    </div>
    <div v-if="!kakao" class="policy">
      <div class="bottom-box">
        <div @click="openNewTab('privacy1')">이용약관</div>
        <div>|</div>
        <div @click="openNewTab('privacy2')">개인정보 처리방침</div>
        <div>|</div>
        <div @click="openNewTab('privacy4')">사업자정보 확인</div>
      </div>
      <div class="deny">
        토노베이션은 통신판매중개자이며 통신판매의 당사자가 아닙니다.
        따라서 토노베이션은 상품/거래정보 및 가격에 대하여 책임을
        지지 않습니다. 본 사이트/앱 상의 모든 정보, 콘텐츠, UI등에 대한 무단 복제, 배포,
        스크래핑 등의 행위는 법에 의하여 엄격히 금지됩니다.
      </div>
      <div class="copyright">
        Copyright TONOVATION Co.,ltd All rights reserved.<br />
        (주)토노베이션 ｜ 사업자등록번호 606-86-60246<br />
        (48059)부산 동래구 온천천로 71, 6층<br />
        TEL. 1661-9068 ｜ FAX. 051-911-9599<br />
        E-mail admin@tonovation.com ｜ 대표이사 박용철
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'company-address',
  props: {
    mapData: Object,
    deliveryTimeValue: String,
    kakao: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    storeMapInfo () {
      return this.mapData
    }
  },
  watch: {
    storeMapInfo () {
      const vm = this
      if (vm.$empty(vm.storeMapInfo)) {
        return
      }
      console.log('loadStoreMap3 :::::', vm.storeMapInfo)
      vm.storeMapInfo.storeTel = vm.changePhoneNumFormat(vm.storeMapInfo.storeTel)
      const { lat, lng, storeName } = vm.storeMapInfo
      const container = vm.$refs.maps
      if (vm.$empty(container)) {
        console.log('loadStoreMap4-1 :::::', vm.$refs.maps)
      } else {
        console.log('loadStoreMap4-2 :::::', container)
        // const position = new window.kakao.maps.LatLng(lat, lng)
        // const options = {
        //   center: position,
        //   level: 4
        // }
        // const map = new window.kakao.maps.Map(container, options)
        // const imageSrc = 'https://tery.kr/images/tery_pin.png'
        // const imageSize = new window.kakao.maps.Size(30, 40)
        // const imageOption = {offset: new window.kakao.maps.Point(15, 40)}
        // const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)

        // var marker = new window.kakao.maps.Marker({
        //   position: position,
        //   image: markerImage,
        //   text: 'test'
        // })
        // marker.setMap(map)
        // let iwContent = ''
        // if (!vm.$empty(storeName)) {
        //   if (Number((storeName.length * 13) + 20) <= 150) {
        //     iwContent = '<div style="width: 150px; padding:5px; text-align: center;">' + storeName + '</div>'
        //   } else {
        //     iwContent = '<div style="width: ' + Number((storeName.length * 13) + 20) + 'px; padding:5px; text-align: center;">' + storeName + '</div>'
        //   }
        // }
        // var iwPosition = position
        // var infowindow = new window.kakao.maps.InfoWindow({
        //   position: iwPosition,
        //   content: iwContent
        // })
        // infowindow.open(map, marker)

        // map.relayout()
        // map.setCenter(position)

        // 이미지 지도에서 마커가 표시될 위치입니다
        const markerPosition = new window.kakao.maps.LatLng(lat, lng)

        // 이미지 지도에 표시할 마커입니다
        // 이미지 지도에 표시할 마커는 Object 형태입니다
        const marker = {
          position: markerPosition,
          text: storeName
        }

        let staticMapOption = {
          center: new window.kakao.maps.LatLng(lat, lng), // 이미지 지도의 중심좌표
          level: 4, // 이미지 지도의 확대 레벨
          marker: marker // 이미지 지도에 표시할 마커
        }

        // 이미지 지도를 생성합니다
        const staticMap = new window.kakao.maps.StaticMap(container, staticMapOption)
        console.log(staticMap)
      }
    }
  },
  mounted () {
    console.log('map2 :::::', this.mapData)
  },
  methods: {
    openNewTab (link) {
      this.moveRouter(link)
    },
    changePhoneNumFormat (num) {
      const vm = this
      let tmpNum = ''
      if (!vm.$empty(num) && num.length === 11) {
        tmpNum = num.substr(0, 3) + ' - ' + num.substr(3, 4) + ' - ' + num.substr(7, 4)
      }
      if (!vm.$empty(num) && num.length === 8) {
        tmpNum = num.substr(0, 4) + ' - ' + num.substr(4, 4)
      }
      if (!vm.$empty(num) && num.length === 10) {
        if (num.substr(0, 2) === '02') {
          tmpNum = num.substr(0, 2) + ' - ' + num.substr(2, 4) + ' - ' + num.substr(6, 4)
        } else {
          tmpNum = num.substr(0, 3) + ' - ' + num.substr(3, 3) + ' - ' + num.substr(6, 4)
        }
      }
      if (!vm.$empty(num) && num.length === 9) {
        if (num.substr(0, 2) === '02') {
          tmpNum = num.substr(0, 2) + ' - ' + num.substr(2, 3) + ' - ' + num.substr(5, 4)
        }
      }
      return tmpNum
    }
  }
}
</script>

<style lang="scss" scoped>
.map__wrap {
  margin-top: 24px;
  .store-map-info__container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    border: #E1E1E1 1px solid;
    border-radius: 30px;
    margin: 0vw 4vw;
    padding: 2vw 8vw;
    .name {
      font-weight: 700;
      font-size: 0.9rem;
    }
    .address {
      font-weight: 400;
      font-size: 11px;
      margin-top: 8px;
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #E1E1E1;
      margin: 12px 0px;
    }
    .bottom {
      width: 100%;
      display: flex;
      flex-direction: row;
      font-weight: 400;
      font-size: 11px;
      color: #2D2D2D;
      .left {
        width: 35%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }
      .right {
        width: 65%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        div:nth-of-type(1) {
          a {
            color: #2D2D2D;
          }
        }
      }
    }
  }
  .map__container {
    width: 100%;
    height: 80vw;
    min-height: 124px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0px;
    div {
      width: 80%;
      height: 100%;
      border: #E1E1E1 1px solid;
      border-radius: 30px;
    }
  }
  .policy {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-radius: 30px 30px 0px 0px;
    background-color: #F2F2F2;
    color: #8A8A8A;
    font-weight: 500;
    font-size: 12px;
    .bottom-box {
      width: 70%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: 16px 0px;
    }
    .deny {
      margin-bottom: 24px;
      padding: 0px 12px;
    }
    .copyright {
      margin-bottom: 16px;
      padding: 0px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companyAddress.vue